import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import Layout from "../components/layout";
import obreroData from '../assets/revistas/obrero-internacional.json';
import * as images from '../assets/revistas/images';


const getImage = (num) => {
  switch (num) {
    case 1: return images.img1;
    case 2: return images.img2;
    case 3: return images.img3;
    case 4: return images.img4;
    case 5: return images.img5;
    case 6: return images.img6;
    case 7: return images.img7;
    default: return images.img1;
  }
};

const useStyles = makeStyles(theme => ({
  boxContenedor: {
    position: 'relative',
    textAlign: "center",
    margin: "2rem",
  },
  boxRevistaHeader: {
    backgroundColor: "#E5332A",
    marginTop: "2rem",
    padding: "3rem 3.5rem",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down('sm')]: {
      padding: "1rem 1.5rem",
      marginTop: "1rem",
    },
  },
  boxRevistaListaLabel: { display: "flex", flexDirection: "column" },
  labelRevistaBoldWhite: {
    color: "white",
    fontSize: "4rem",
    fontFamily: "FuturaBold",
    lineHeight: "1.5rem",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.3rem",
    },
  },
  labelRevistaBoldWhiteLittle: {
    color: "white",
    fontFamily: "FuturaBold",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.5rem",
    },
  },
}));

function RevistaObreroHeader() {
  const classes = useStyles();
  return (
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>El Obrero Internacional</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{ alignSelf: "center" }}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Nº 1 al 7</span>
        <span style={{ color: "white" }}>(2004-2007)</span>
      </Box>
    </Box>
  );
}

function ElObreroInternacional(props) {
  const classes = useStyles();

  return (
    <Layout>
      <RevistaObreroHeader />
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Box style={{ padding: '2rem' }}>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {obreroData.map(item => {
              const match = item.nombre.match(/-(\d+)\.pdf$/);
              const numberStr = match?.[1];
              //console.log('nombre:', item.nombre, 'match:', numberStr); // <-- debug
              const number = numberStr ? Number(numberStr) : 1; 
              const imageSrc = getImage(number);
              return (
                <Box key={item.id} style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '6px', maxWidth: "400px" }}>
                  <Box display="flex" alignItems="center">
                    <img
                      src={imageSrc}
                      alt={item.titulo}
                      style={{ width: 135, height: 180, objectFit: 'cover', marginRight: "2rem" }}
                    />
                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                      <h3>{item.titulo}</h3>
                      <Box mb="20px">
                        <a href={item.url} target="_blank" rel="noopener noreferrer">
                          <Button variant='contained'>Ver</Button>
                        </a>
                      </Box>
                      <Box>
                        <a href={item.url} download>
                          <Button variant='contained'>Descargar</Button>
                        </a>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
}

export default withWidth()(ElObreroInternacional);